import React from 'react';

import cookie from 'react-cookies';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import connect from 'react-redux/lib/connect/connect';
import bindActionCreators from 'redux/lib/bindActionCreators';

import * as RouteDucks from 'ducks/routes';
import * as CustomerDucks from 'ducks/customers/customer';
import * as CustomerTagDucks from 'ducks/customers/tag';

import TwoColumnLayout from 'layouts/TwoColumn';
import CustomerListSection from 'sections/customers/list/list';
import CustomerFilterSection from 'sections/customers/list/Filter';

import { NAV } from 'constants/customers';

/**
 * CustomersListPage
 *
 * Layout:
 *    - {@link TwoColumnLayout}
 *
 * Sections:
 *    - {@link CustomerFilterSection}
 *    - {@link CustomerListSection}
 *
 * Fetch Needs:
 *    - getEmployees
 */
class CustomerListPage extends React.Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.toggleInfo = this.toggleInfo.bind(this);
    this.state = { isLoading: false, isInfoOpen: true };
  }

  componentWillMount() {
    const cookieKey = cookie.load("customer_info");
    this.setState({ isLoading: true });
    if(cookieKey) {
      this.setState({isInfoOpen: JSON.parse(cookieKey)});
    }
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    const { location: { query: prevQuery } } = this.props;
    const { location: { query: nextQuery } } = nextProps;
    if (prevQuery !== nextQuery) {
      this.fetchData(nextQuery);
    }
  }

  loadData(){
    const { router: { history } } = this.context;
    const { location: { pathname, query } } = this.props;
    if (
      !('is_active' in query)){
      history.push({
        pathname,
        search: queryString.stringify({
          ...query,
          is_active: true,
        }),
      });
    }else{
      this.fetchData(query);
    } 
  }

  fetchData(params) {
    this.setState({ isLoading: true });
    const pageSize = cookie.load("customer_page_size");
    Promise.all([
      this.props.CustomerDucks.getCustomers({ ...params, page_size: pageSize }),
      this.props.CustomerTagDucks.getCustomerTags({...params,  paginate: false, tag_type: 0 }),
    ])
      .then(() => this.setState({ isLoading: false }))
      .catch(() => this.setState({ isLoading: false })); 
  }

  toggleInfo(){
    const { isInfoOpen } = this.state;
    this.setState({ isInfoOpen: !isInfoOpen });
    cookie.save("employee_info", !isInfoOpen);
  }

  render() {
    const { isLoading, isInfoOpen } = this.state;
    const { infoList } = this.props;
    return (
      <TwoColumnLayout
        navInfo={NAV.CustomerListPage}
        infoList={infoList}
        toggleInfo={this.toggleInfo}
        isInfoOpen={isInfoOpen}
        fetchData={this.loadData}
        jobPage={true}
        isLoading={isLoading}
      >
        <CustomerFilterSection isLoading={isLoading}/>
        <CustomerListSection isLoading={isLoading} />
      </TwoColumnLayout>
    );
  }
}

const mapStateToProps = state => ({
  location: RouteDucks.location(state),
  customerList:CustomerDucks.customerList(state),
});

const mapActionsToProps = dispatch => ({
  CustomerDucks: bindActionCreators(CustomerDucks, dispatch),
  CustomerTagDucks: bindActionCreators(CustomerTagDucks, dispatch),
});

CustomerListPage.propTypes = {
  location: PropTypes.object.isRequired,
  CustomerDucks: PropTypes.object.isRequired,
};

CustomerListPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(CustomerListPage);
